import script from "./BlogImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogImage.vue?vue&type=script&setup=true&lang=ts"

import "./BlogImage.vue?vue&type=style&index=0&id=155f5709&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-155f5709"]])

export default __exports__